import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function Users({ currentUser }) {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [newUser, setNewUser] = useState({ username: '', password: '', full_name: '', email: '', phone: '', role: 'doctor' });
    const [roleFilter, setRoleFilter] = useState('all');

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = () => {
        axios.get('./backend/get_users.php')
            .then(res => {
                setUsers(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isEditing) {
            // Güncelleme (Backend endpoint'i varsayılıyor veya eklenecek)
            axios.post('./backend/update_user.php', { ...newUser, id: currentId })
                .then(res => {
                    toast.success(res.data.message);
                    setShowModal(false);
                    fetchUsers();
                })
                .catch(err => toast.error(err.response?.data?.message || 'Güncelleme başarısız.'));
        } else {
            // Ekleme
            axios.post('./backend/add_user.php', newUser)
                .then(res => {
                    toast.success(res.data.message);
                    setShowModal(false);
                    fetchUsers();
                })
                .catch(err => toast.error(err.response?.data?.message || 'İşlem başarısız.'));
        }
    };

    const openAddModal = () => {
        setNewUser({ username: '', password: '', full_name: '', email: '', phone: '', role: 'doctor' });
        setIsEditing(false);
        setShowModal(true);
    };

    const openEditModal = (user) => {
        setNewUser({ username: user.username, password: '', full_name: user.full_name, email: user.email || '', phone: user.phone || '', role: user.role });
        setCurrentId(user.id);
        setIsEditing(true);
        setShowModal(true);
    };

    const handleDelete = (id) => {
        if (id === currentUser.id) {
            toast.error("Kendinizi silemezsiniz.");
            return;
        }
        if(window.confirm('Bu kullanıcıyı silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_user.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchUsers();
                });
        }
    };

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus == 1 ? 0 : 1;
        if(window.confirm(`Kullanıcıyı ${newStatus ? 'aktif' : 'pasif'} yapmak istediğinize emin misiniz?`)) {
            axios.post('./backend/toggle_user_status.php', { id, is_active: newStatus })
                .then(res => {
                    toast.success(res.data.message);
                    fetchUsers();
                })
                .catch(err => toast.error('İşlem başarısız.'));
        }
    };

    if (loading) return <div>Yükleniyor...</div>;

    const filteredUsers = users.filter(u => {
        if (roleFilter === 'all') return true;
        return u.role === roleFilter;
    });

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Kullanıcı Yönetimi</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <select value={roleFilter} onChange={(e) => setRoleFilter(e.target.value)} style={{ padding: '8px', borderRadius: '20px', border: '2px solid #eaecf4' }}>
                        <option value="all">Tüm Roller</option>
                        <option value="admin">Yöneticiler</option>
                        <option value="doctor">Doktorlar</option>
                        <option value="staff">Personeller</option>
                    </select>
                    <button className="add-btn" onClick={openAddModal}>+ Yeni Kullanıcı Ekle</button>
                </div>
            </div>

            <table className="data-table users-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Ad Soyad</th>
                        <th>Kullanıcı Adı</th>
                        <th>E-posta</th>
                        <th>Telefon</th>
                        <th>Rol</th>
                        <th>Kayıt Tarihi</th>
                        <th>Son Giriş</th>
                        <th>Son IP</th>
                        <th>Durum</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredUsers.map(u => (
                        <tr key={u.id}>
                            <td data-label="ID">{u.id}</td>
                            <td data-label="Ad Soyad" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <img 
                                    src={u.profile_image || 'https://zertucha.com/demos/dentis/uploads/logo_1770576275.png'} 
                                    alt="Avatar" 
                                    style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover' }} 
                                />
                                {u.full_name} {u.id === currentUser.id ? '(Siz)' : ''}
                            </td>
                            <td data-label="Kullanıcı Adı">{u.username}</td>
                            <td data-label="E-posta">{u.email || '-'}</td>
                            <td data-label="Telefon">{u.phone || '-'}</td>
                            <td data-label="Rol"><span className={`status-badge ${u.role === 'admin' ? 'status-cancelled' : (u.role === 'doctor' ? 'status-completed' : 'status-scheduled')}`}>{u.role === 'admin' ? 'Yönetici' : (u.role === 'doctor' ? 'Doktor' : 'Personel')}</span></td>
                            <td data-label="Kayıt Tarihi">{new Date(u.created_at).toLocaleDateString()}</td>
                            <td data-label="Son Giriş">{u.last_login ? new Date(u.last_login).toLocaleString() : '-'}</td>
                            <td data-label="Son IP">{u.last_login_ip || '-'}</td>
                            <td data-label="Durum">
                                <button 
                                    className={`status-badge ${u.is_active == 1 ? 'status-completed' : 'status-cancelled'}`} 
                                    onClick={() => handleToggleStatus(u.id, u.is_active)}
                                    style={{ border: 'none', cursor: 'pointer', fontSize: '0.8rem' }}
                                >
                                    {u.is_active == 1 ? 'Aktif' : 'Pasif'}
                                </button>
                            </td>
                            <td data-label="İşlemler">
                                <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                    {u.id !== currentUser.id && (
                                        <button className="edit-btn" onClick={() => openEditModal(u)}>Düzenle</button>
                                    )}
                                    {u.id !== currentUser.id && (
                                        <button className="delete-btn" onClick={() => handleDelete(u.id)}>Sil</button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{isEditing ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı Ekle'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="userForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Ad Soyad</label>
                                    <input type="text" value={newUser.full_name} onChange={e => setNewUser({...newUser, full_name: e.target.value})} required />
                                </div>
                                <div className="form-group">
                                    <label>Kullanıcı Adı</label>
                                    <input type="text" value={newUser.username} onChange={e => setNewUser({...newUser, username: e.target.value})} required />
                                </div>
                                <div className="form-group">
                                    <label>E-posta</label>
                                    <input type="email" value={newUser.email} onChange={e => setNewUser({...newUser, email: e.target.value})} />
                                 </div>
                                 <div className="form-group">
                                    <label>Telefon</label>
                                    <input type="text" value={newUser.phone} onChange={e => setNewUser({...newUser, phone: e.target.value})} placeholder="05..." />
                                 </div>
                                 <div className="form-group">
                                    <label>Rol</label>
                                    <select value={newUser.role} onChange={e => setNewUser({...newUser, role: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                        <option value="doctor">Doktor</option>
                                        <option value="staff">Personel</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Şifre</label>
                                    <input type="password" value={newUser.password} onChange={e => setNewUser({...newUser, password: e.target.value})} required={!isEditing} placeholder={isEditing ? "Değiştirmek için girin" : ""} />
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="userForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Users;